import { useState, useEffect } from 'react';
import useTombFinance from './useTombFinance';
import { getDisplayBalance } from '../utils/formatBalance';

const useBurnedBalances = () => {
  const [burnedBalances, setBurnedBalances] = useState({
    hog: 0,
    hogOsLp: 0,
    ghogOsLp: 0
  });
  const [tokenPrices, setTokenPrices] = useState({
    hog: 0,
    hogOsLp: 0,
    ghogOsLp: 0
  });
  const tombFinance = useTombFinance();

  useEffect(() => {
    const fetchBurnedBalances = async () => {
      if (tombFinance) {
        try {
          const balances = await tombFinance.getZeroAddressBalances();
          const hogStats = await tombFinance.getTombStat();
          
          // Get LP token prices
          const hogOsLpPrice = await tombFinance.getLPTokenPrice(
            tombFinance.externalTokens['HOG-OS-LP'],
            tombFinance.HOG,
            true
          );
          
          const ghogOsLpPrice = await tombFinance.getLPTokenPrice(
            tombFinance.externalTokens['GHOG-OS-LP'],
            tombFinance.GHOG,
            false
          );

          setBurnedBalances({
            hog: Number(getDisplayBalance(balances.hog, 18, 18)),
            hogOsLp: Number(getDisplayBalance(balances.hogOsLp, 18, 18)),
            ghogOsLp: Number(getDisplayBalance(balances.ghogOsLp, 18, 18))
          });

          setTokenPrices({
            hog: Number(hogStats.priceInDollars),
            hogOsLp: Number(hogOsLpPrice),
            ghogOsLp: Number(ghogOsLpPrice)
          });

        } catch (error) {
          console.error('Error fetching burned balances:', error);
        }
      }
    };

    fetchBurnedBalances();
    // Set up an interval to refresh data every minute
    const interval = setInterval(fetchBurnedBalances, 60000);
    return () => clearInterval(interval);
  }, [tombFinance]);

  return {
    burnedBalances,
    tokenPrices,
    burnedValueUSD: {
      hog: burnedBalances.hog * tokenPrices.hog,
      hogOsLp: burnedBalances.hogOsLp * tokenPrices.hogOsLp,
      ghogOsLp: burnedBalances.ghogOsLp * tokenPrices.ghogOsLp
    }
  };
};

export default useBurnedBalances; 